import React from 'react'
import { FiArrowUpRight, FiLinkedin } from 'react-icons/fi'
import AnimatedBrandMark from '../../components/AnimatedBrandMark'
import './footer.css'

const LINKEDIN_URL = 'https://www.linkedin.com/in/anastasiia-r-2164991a9/'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="site-footer" aria-label="Pied de page / Site footer">
      <div className="site-footer__signal" aria-hidden="true">
        <span />
        <i />
        <span />
      </div>

      <div className="site-footer__inner">
        <div className="site-footer__main">
          <div className="site-footer__brand">
            <AnimatedBrandMark className="site-footer__brand-mark" />
            <div>
              <p className="site-footer__wordmark">OctoSynapse</p>
              <p className="site-footer__promise">
                <span lang="fr">Une langue ne disparaît jamais.</span>
                <small lang="en">A language never truly leaves you.</small>
              </p>
            </div>
          </div>

          <div className="site-footer__creator">
            <p className="site-footer__creator-label">
              <span lang="fr">Conçu et développé par</span>
              <small lang="en">Designed &amp; developed by</small>
            </p>

            <a
              className="site-footer__creator-link"
              href={LINKEDIN_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Anastasiia R. sur LinkedIn / Anastasiia R. on LinkedIn (nouvel onglet / new tab)"
            >
              <FiLinkedin className="site-footer__linkedin-icon" aria-hidden="true" />
              <span>Anastasiia R.</span>
              <FiArrowUpRight className="site-footer__external-icon" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="site-footer__legal">
          <p>© {currentYear} OctoSynapse</p>
          <p>
            <span lang="fr">Réactivation linguistique immersive</span>
            <span aria-hidden="true"> · </span>
            <span lang="en">Immersive language reactivation</span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
